import { writable } from 'svelte/store';


// Booleans Variables
export const isEmptyInput = writable(false)
export const isModalAttendesOn = writable(false)
export const isModalEventsOn = writable(false)
export const isModalMeetingsOn = writable(false)
export const isModalCoordinatorsOn = writable(false)
export const isUploadFilesModalOn = writable(false)
export const isAttendeeCardModalOn = writable(false)
export const isCustomTableModalOn =  writable(false)
export const isOnetoOneMeetingsOn = writable(false)
export const isChatModalOn = writable(false)
export const isProtectedRoute = writable(false)
export const isPreviewEventPageModal = writable(false)
export const isPollModalOn = writable(false)
export const isEmptyChatBox = writable(false)
export const isOpenChat = writable(false)
export const isAttendeeMeetModalOn = writable(false)
export const isAlertOn = writable(false)
export const isReloadNecessary = writable(false)
export const isConfirmModalOn = writable(false)
export const confirmResponse = writable(false)
export const chatsActive = writable(true)
export const dinamicChat = writable(true)
export const noSlotsModalOn = writable(false)

//Confirm modal variables
export const confirmDeleteBreak = writable(false)
export const confirmDeletePoll = writable(false)
export const confirmDeleteCustomTable = writable(false)

//Updating/Creating Data Variables
export const isModalUpdate = writable(false)
export const isUpdateTableModal = writable(false)
export const isUpdatingPollsModal = writable(false)
export const objData = writable({})
export const breakInfo = writable({})
export const lastMeetScheduled = writable ({})
export const meetingInfo = writable({})

//Variables to store data
export const eventsData = writable([])
export const meetingsData = writable([])
export const attendeesData = writable([])
export const coordinatorsData = writable([])
export const excelAttendeeData = writable([])
export const updateDataExcel = writable([])
export const invitedAttendeesArray = writable([])
export const attendeesUnavailableMeets = writable([])
export const allChats = writable([])
export const meetsArray = writable([])
export const pollsArray = writable([])
export const userRealTime = writable({})
export const eventRealTime = writable({})

//Temporal storage variables
export const indexPositionData = writable(0)
export const temporalData = writable({})
export const temporalBreakData = writable({})
export const temporalAttendeeData = writable({})
export const userLocalData = writable({})
export const temporalAttendee = writable({})
export const temporalChatAttendee = writable({})
export const temporalPollData = writable({})
export const temporalMeetInfo = writable({})
export const temporalEventList = writable({})
export const currentEvent = writable("")
export const indexBreakData = writable("")
export const customBreakId = writable("")
export const chatId = writable("")
export const confirmationResponse = writable("")
export const alertMessagge = writable("")
export const deleteMessagge = writable("")
